<div class="productTags">
  <span *ngFor="let tag of tags" class="productTags__tag">
    <span *ngIf="tag === 'welove'">We Love</span>
    <span *ngIf="tag === 'vintage'">Vintage</span>
  </span>
</div>
